import React, { useState } from 'react';

import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import _ from 'lodash';

import CopyHistoricalDialog from './copy_historical_dialog';
import SectionPaper from "../../../../../common/section_paper";

const AdditionalOptions = ({ onChangeSetDate, form, onCopyHistoricalDocument }) => {
    const [allDates, setAllDates] = useState(false);
    const onChangeSetDateDebounced = _.debounce((value) => onChangeSetDate(value, allDates), 600);

    return (
        <SectionPaper title="Opcje dodatkowe">
            <Box sx={ {
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'center' },
                gap: 3
            } }>
                <Stack direction="row" spacing={ 3 } alignItems="center" flexWrap="wrap" useFlexGap>
                    <DatePicker
                        displayWeekNumber
                        label="Ustaw datę przydatności"
                        onChange={ newDate => newDate?.isValid() && onChangeSetDateDebounced(newDate) }
                        slotProps={ {
                            textField: {
                                size: "small",
                                sx: { width: 250 }
                            }
                        } }
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={ allDates }
                                onChange={ (e) => setAllDates(e.target.checked) }
                            />
                        }
                        label={ <Typography variant="body2">Uzupełnij dla wszystkich lokalizacji</Typography> }
                        sx={ { m: 0 } }
                    />
                </Stack>

                <Box>
                    <CopyHistoricalDialog
                        form={ form }
                        onCopyHistoricalDocument={ onCopyHistoricalDocument }
                    />
                </Box>

            </Box>
        </SectionPaper>
    );
};

export default AdditionalOptions;